import { render } from "./OidcCallback.vue?vue&type=template&id=00a76c6e"
import script from "./OidcCallback.vue?vue&type=script&lang=js"
export * from "./OidcCallback.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/OidcCallback.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "00a76c6e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('00a76c6e', __exports__)) {
    api.reload('00a76c6e', __exports__)
  }
  
  module.hot.accept("./OidcCallback.vue?vue&type=template&id=00a76c6e", () => {
    api.rerender('00a76c6e', render)
  })

}


export default __exports__